import { waitGetAny } from '@zk/util';

import { useRootInstance } from './useRootInstance';

export const waitForDefaultLayout = async (getFunc?: () => any) => {
  useRootInstance().eventBus.$emit('global:showDefaultLayout');
  const fn = getFunc || (() => document.querySelector('.zk-default-layout'));
  const el = await waitGetAny(fn);
  return !!el;
};
